import { ScheduleBuilder } from './schedule.builder';
import { LineStatus } from './lines-settings.i';
import { VoiceMessageBuilder } from './voice-message.builder';
var LineBuilder = /** @class */ (function () {
    function LineBuilder() {
        this.line = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            default: false,
            phoneNumber: '+9999999999999',
            ivrId: '',
            name: 'bob',
            description: 'dod',
            status: LineStatus.ACTIVE,
            inactiveLineVoiceMessage: new VoiceMessageBuilder().build(),
            callBackVoiceMessage: new VoiceMessageBuilder().build(),
            callBackTextMessage: {
                text: 'default text message',
                enabled: false
            },
            schedule: new ScheduleBuilder().build(),
            creationDate: Date.now() - 3600000,
            lastUpdateDate: Date.now(),
            inboundEnabled: true,
            outboundEnabled: false,
            whatsAppEnabled: false,
            smsEnabled: false,
            smsLineSettings: {
                defaultSmsLine: false,
                smsInboundEnabled: true,
                smsOutboundEnabled: false,
            }
        };
    }
    LineBuilder.prototype.withPhoneNumber = function (phoneNumber) {
        this.line.phoneNumber = phoneNumber;
        return this;
    };
    LineBuilder.prototype.withId = function (id) {
        this.line.id = id;
        return this;
    };
    LineBuilder.prototype.withDefault = function (isDefault) {
        this.line.default = isDefault;
        return this;
    };
    LineBuilder.prototype.withIvrId = function (id) {
        this.line.ivrId = id;
        return this;
    };
    LineBuilder.prototype.withInboundEnabled = function (value) {
        this.line.inboundEnabled = value;
        return this;
    };
    LineBuilder.prototype.withOutboundEnabled = function (value) {
        this.line.outboundEnabled = value;
        return this;
    };
    LineBuilder.prototype.withName = function (name) {
        this.line.name = name;
        return this;
    };
    LineBuilder.prototype.withDescription = function (description) {
        this.line.description = description;
        return this;
    };
    LineBuilder.prototype.withStatus = function (status) {
        this.line.status = status;
        return this;
    };
    LineBuilder.prototype.withInactiveLineVoiceMessage = function (inactiveLineVoiceMessage) {
        this.line.inactiveLineVoiceMessage = inactiveLineVoiceMessage;
        return this;
    };
    LineBuilder.prototype.withCallBackVoiceMessage = function (callBackVoiceMessage) {
        this.line.callBackVoiceMessage = callBackVoiceMessage;
        return this;
    };
    LineBuilder.prototype.withCallBackTextMessage = function (callBackTextMessage) {
        this.line.callBackTextMessage = callBackTextMessage;
        return this;
    };
    LineBuilder.prototype.withSchedule = function (schedule) {
        this.line.schedule = schedule;
        return this;
    };
    LineBuilder.prototype.withCreationDate = function (creationDate) {
        this.line.creationDate = creationDate;
        return this;
    };
    LineBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.line.lastUpdateDate = lastUpdateDate;
        return this;
    };
    LineBuilder.prototype.withWhatsAppEnabled = function (value) {
        this.line.whatsAppEnabled = value;
        return this;
    };
    LineBuilder.prototype.withSmsEnabled = function (value) {
        this.line.smsEnabled = value;
        return this;
    };
    LineBuilder.prototype.withSmsLineSettings = function (smsLineSettings) {
        this.line.smsLineSettings = smsLineSettings;
        return this;
    };
    LineBuilder.prototype.build = function () {
        return this.line;
    };
    return LineBuilder;
}());
export { LineBuilder };
//# sourceMappingURL=lines-settings.builder.js.map